import { Button, cn } from "@dune/ui";
import { useDocumentStore } from "../../../stores/document.store";

type PreviewFileLinkProps = {
	file: {
		id: string;
		name: string;
	};
	className?: string;
};

export const PreviewFileLink = ({ file, className }: PreviewFileLinkProps) => {
	const selectDocument = useDocumentStore((state) => state.selectDocument);
	return (
		<Button
			variant="link"
			className={cn(
				"p-0 py-1 h-auto font-normal text-primary text-left justify-start min-w-0",
				className,
			)}
			onClick={() => selectDocument("", file.id, "", file.name)}
			title={file.name}
		>
			<span className="truncate w-full min-w-0">{file.name}</span>
		</Button>
	);
};
